export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6890.46f2c037.jpg";